export const  ADD_CALCULATED_FIELD = ' ADD_CALCULATED_FIELD';
export const REMOVE_QUESTION = 'REMOVE_QUESTION'
export const ADD_STEP = 'ADD_STEP';
export const SETCURRENT_STEP = 'SETCURRENT_STEP';
export const ADD_LOADED_DRAFT_FORM = 'ADD_LOADED_DRAFT_FORM'

export const addCalculatedFieldData = (text) => ({
    type: ADD_CALCULATED_FIELD,
    payload: text
});

export const addStepData = (text) => ({
    type: ADD_STEP,
    payload: text
});

export const addStepDataPromise = (id, name, questions) => {
    return dispatch => {       
            dispatch(addStepData({
                stepid: id,
                name: name,
                questions: questions
            }))
    }
}

export const setCurrentStep = (text) => ({
    type: SETCURRENT_STEP,
    payload: text
});

export const addDraftFormData = (text) => ({
    type: ADD_LOADED_DRAFT_FORM,
    payload: text
});

export const addDraftFormDataPromise = (draftformdata) => {
    return dispatch => {
        dispatch(addDraftFormData({
            steps: draftformdata.steps,
            currentstep: draftformdata.currentstep
        }))
    }
};